import * as React from 'react';
import styled from 'styled-components';
import { media } from '../../../utilities/media';
const MobileSizeLogo = styled.div `
  display: block;
  ${media.tablet `display: none;`};
`;
const TabletSizeLogo = styled.div `
  display: none;
  ${media.tablet `display: block;`};
`;
const StyledLogo = styled.a `
  width: 100%;
  height: 48px;
  padding: 8px 0;
  display: flex;
  border: none;
  align-items: center;
  cursor: pointer;

  ${media.tablet `
    padding: 10px 0;
    height: 76px;
  `};
`;
export class Logo extends React.PureComponent {
    render() {
        return (React.createElement(StyledLogo, Object.assign({}, this.props),
            React.createElement(MobileSizeLogo, null,
                React.createElement("img", { src: window._ASSETS.MFLogoPhone })),
            React.createElement(TabletSizeLogo, null,
                React.createElement("img", { src: window._ASSETS.MFLogoDesktop }))));
    }
}
//# sourceMappingURL=Logo.js.map